import React, { useState, useEffect, forwardRef } from 'react'
import './css/new-collections.css'
import Item from './Item'
import ItemSkeleton from '../skeletons/Item'

const NewCollections = forwardRef((props, ref) => {

    const [new_collection, setNewCollection] = useState([]);
    const [loading, setLoading] = useState(true);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch(`${backendUrl}/new-collection`);
            const data = await res.json();
            if (data.success) {
                setNewCollection(data.products);
                setLoading(false);
            }
        };
        fetchData();
    }, [backendUrl]);

    return (
        <div ref={ref} className='new-collections'>
            <h1>NEW COLLECTIONS</h1>
            <hr />
            <div className="collections">
                {loading ? (
                    <ItemSkeleton />
                ) : new_collection.length > 0 ? (
                    new_collection.map((item, i) => (
                        <Item
                            key={i}
                            id={item._id}
                            image={item.primaryImage}
                            name={item.name}
                            new_price={item.new_price}
                            old_price={item.old_price}
                        />
                    ))
                ) : (
                    <p className="no-products">No new collection products found.</p>
                )}
            </div>
        </div>
    )
});

export default NewCollections;